export const readtime = (content: string | undefined | null) => {
    if (!content) return 0;

    content = content.trim().replace(/<[^>]*>?/gm, '');

    // add a space after every interpunction
    content = content.replace(/([.,?!])([^\s])/g, '$1 $2');

    // clean up interpunction and other stuff, so we can count the words correctly
    content = content.replace(/[^a-zA-Z0-9\s]/g, '');

    // remove object Object
    content = content.replace('object Object', 'dummy');

    // remove multiple spaces
    content = content.replace(/\s\s+/g, ' ');

    // remove leading and trailing spaces
    content = content.trim();

    const words = content.split(' ').length;
    const time = Math.ceil(words / 265);
    return time;
};

export function shuffle(array: any[]) {
    let currentIndex = array.length;
  
    while (currentIndex != 0) { 
      let randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
  
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]];
    }

    // return new instance of the array
    return [...array];
  }